var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailedValidationBullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5015 7.99805L12.4999 12.9996M12.4999 12.9996C12.4999 12.9996 15.5961 16.0958 17.5015 18.0011M12.4999 12.9996L7.49841 18.0011M12.4999 12.9996L7.49841 7.99805",
    stroke: "#D24345",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedValidationBullet);
export default __webpack_public_path__ + "static/media/failedValidationBullet.71884f02716a15b7902fdbd59f8d4887.svg";
export { ForwardRef as ReactComponent };